import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import Image from 'gatsby-image'

import { WebsiteIcon } from '@epi/epi-ui/es/websites'


function Bio () {

  return (
    <StaticQuery
      query={bioQuery}
      render={data => {
        return (
          <div className="Bio">
            <p>
              This is a movement started by the makers of <a href="https://epihq.com">Epi <WebsiteIcon name="chevron-circle-right" fill /></a>
              {` `}
            </p>
          </div>
        )
      }}
    />
  )
}

const bioQuery = graphql`
  query BioQuery {
    avatar: file(absolutePath: { regex: "/profile-pic.jpg/" }) {
      childImageSharp {
        fixed(width: 50, height: 50) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`

export default Bio
